// see https://github.com/gf3/Levenshtein

function forEach(array: string, fn) {
    var i, length;
    i = -1;
    length = array.length;
    while (++i < length)
        fn(array[i], i, array);
}

function map(array: string, fn) {
    var result;
    result = Array(array.length);
    forEach(array, function (val, i, array) {
        result[i] = fn(val, i, array);
    })
    return result
}

function reduce(array: string, fn, accumulator) {
    forEach(array, function (val, i, array) {
        accumulator = fn(val, i, array);
    })
    return accumulator;
}

// Levenshtein distance
class Levenshtein {
    distance: number;
    _matrix: Array<number>;

    static about = `Levenshtein distance algorithm`;

    constructor(str_m: string, str_n: string) {
        var previous, current, matrix
        // Constructor
        matrix = this._matrix = []

        // Sanity checks
        if (str_m == str_n)
            this.distance = 0;
        else if (str_m == '')
            this.distance = str_n.length;
        else if (str_n == '')
            this.distance = str_m.length;
        else {
            // Danger Will Robinson
            previous = [0]
            forEach(str_m, function (v, i) { i++ , previous[i] = i })

            matrix[0] = previous
            forEach(str_n, function (n_val, n_idx) {
                current = [++n_idx]
                forEach(str_m, function (m_val, m_idx) {
                    m_idx++
                    if (str_m.charAt(m_idx - 1) == str_n.charAt(n_idx - 1))
                        current[m_idx] = previous[m_idx - 1]
                    else
                        current[m_idx] = Math.min
                            (previous[m_idx] + 1   // Deletion
                            , current[m_idx - 1] + 1   // Insertion
                            , previous[m_idx - 1] + 1   // Subtraction
                            )
                })
                previous = current
                matrix[matrix.length] = previous
            })

            this.distance = current[current.length - 1];
        }
    }

    toString() {
        return this.inspect();
    }

    inspect() {
        var matrix, max, buff, sep, rows;
        matrix = this.getMatrix();
        max = reduce(matrix, function (m, o) {
            return Math.max(m, reduce(o, Math.max, 0));
        }, 0);

        buff = Array((max + '').length).join(' ');

        sep = [];
        while (sep.length < (matrix[0] && matrix[0].length || 0))
            sep[sep.length] = Array(buff.length + 1).join('-');

        sep = sep.join('-+') + '-';

        rows = map(matrix, function (row) {
            var cells;
            cells = map(row, function (cell) {
                return (buff + cell).slice(- buff.length);
            })
            return cells.join(' |') + ' ';
        })

        return rows.join("\n" + sep + "\n");
    }

    getMatrix() {
        return this._matrix.slice();
    }

    valueOf() {
        return this.distance;
    }
}

export = Levenshtein;

